<template>
  <div class="form-group">
    <label class="form-label"><slot></slot></label>
    <input
        :value="modelValue"
        ref="input"
        :name="name"
        :id="id"
        :type="type"
        :placeholder="placeholder"
        :max="max"
        :min="min"
        :class="{'form-text': true, 'error-input': errors.length !== 0}"
        @input="$emit('update:modelValue', $event.target.value)"
        @blur.stop="onBlur"
    >

    <ul>
      <li v-for="(hint, index) of hints" :key="index">
        <span class="hint-message">{{hint}}</span>
      </li>
    </ul>
    <ul>
      <li v-for="(error, index) of errors" :key="index">
        <strong class="error-message">{{error.$message}}</strong>
      </li>
    </ul>
  </div>
</template>

<script>
import Inputmask from 'inputmask'

export default {
  name: "InputWithLabel",
  emits: [
      'update:modelValue',
      'blur',
  ],
  methods: {
    async onBlur(event) {
      await this.$emit('blur', event);

      if (this.scrollIntoViewIfErrors && this.errors.length !== 0) {
        const input = this.$refs.input;

        let top = window.scrollY + input.getBoundingClientRect().y - document.body.clientHeight / 2;

        window.scroll({
          top,
          behavior: 'smooth',
        });
      } // if.
    },
  },
  props:{
    type: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: false,
      default: ''
    },
    id: {
      type: String,
      required: false,
      default: ''
    },
    placeholder: {
      type: String,
      required: false,
      default: ''
    },
    max: {
      type: String,
      required: false,
      default: '',
    },
    min: {
      type: String,
      required: false,
      default: '',
    },
    mask: {
      type: String,
      required: false,
      default: '',
    },
    hints: {
      type: Array,
      required: false,
      default () {
        return []
      }
    },
    errors: {
      type: Array,
      required: false,
      default (){
        return []
      },
    },
    scrollIntoViewIfErrors: {
      type: Boolean,
      required: false,
      default: false,
    },
    modelValue: {
      type: String
    }
  },
  mounted() {
    if(this.mask !== ''){
      // Получаем ссылку на инпут.
      const input = this.$refs.input;

      // Создаём экземпляр класса для создания маски на тексте.
      const inputMask = new Inputmask(this.mask);

      // Делаем маску.
      inputMask.mask(input);
    } // if.
  },
}
</script>

<style scoped>
  .hint-message{
    color: #7a7a7a;
    font-size: 13px;
  }

  .error-message, .hint-message {
    animation-name: Appearance;
    animation-duration: 1s;
    animation-timing-function: cubic-bezier(.1,-.6,.2,0);
  }

  @-webkit-keyframes Appearance {
    0% {opacity: 0;}
    100% {opacity: 1;}
  }

  @-o-keyframes Appearance {
    0% {opacity: 0;}
    100% {opacity: 1;}
  }

  @-moz-keyframes Appearance {
    0% {opacity: 0;}
    100% {opacity: 1;}
  }

  ul{
    list-style-type: none;
  }

</style>